import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import HINTERGRUND from "../assets/kontakt.jpg";

const Contact: React.FC = () => {
  const formRef = useRef<HTMLFormElement>(null);

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();

    if (!formRef.current) return;

    emailjs
      .sendForm(
        "service_1go8ovc",     
        "template_7arzykq",
        formRef.current,
        "hQGccF0cVHqIGpBIY"
      )
      .then(
        () => {
          alert("Nachricht wurde erfolgreich gesendet!");
          formRef.current?.reset();
        },
        (error) => {
          console.error("EmailJS Fehler:", error);
          alert("Fehler beim Senden der Nachricht.");
        }
      );
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      {/* HERO */}
      <section
        className="relative flex items-center justify-center text-center
                  h-[50vh] md:h-[60vh] sm:h-[40vh]"
        style={{
          backgroundImage: `url(${HINTERGRUND})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Dunkles Overlay */}
        <div className="absolute inset-0 bg-black/50" />
        
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-20 md:py-28 text-center">
          <h1 className="text-4xl font-bold text-white mb-4">Kontakt</h1>
          <p className="text-white max-w-2xl mx-auto">
            Haben Sie Fragen oder wünschen ein unverbindliches Angebot?
          </p>
        </div>
      </section>

      {/* FORM */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-12">
          {/* INFO */}
          <div>
            <h2 className="text-2xl font-semibold mb-6">
              A.B.S. GmbH – Gebäudesanierung und Renovierung
            </h2>
            <p className="text-gray-700">
              Talweg 2G<br />
              85614 Kirchseeon<br /><br />
              Tel: +49 176 57122695<br />
              Mail: info-abs-gmbh@mail.de
            </p>
          </div>

          {/* FORMULAR */}
          <div className="bg-white rounded-xl shadow p-8">
            <h2 className="text-2xl font-semibold mb-6">
              Nachricht senden
            </h2>

            <form ref={formRef} onSubmit={sendEmail} className="space-y-5">
              <input
                type="text"
                name="from_name"
                placeholder="Ihr Name"
                required
                className="w-full border rounded-lg px-4 py-2"
              />

              <input
                type="email"
                name="from_email"
                placeholder="Ihre E-Mail"
                required
                className="w-full border rounded-lg px-4 py-2"
              />

              <input
                type="tel"
                name="phone"
                placeholder="Telefon (optional)"
                className="w-full border rounded-lg px-4 py-2"
              />

              <textarea
                name="message"
                rows={4}
                placeholder="Ihre Nachricht"
                required
                className="w-full border rounded-lg px-4 py-2"
              />

              <button
                type="submit"
                className="w-full bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700"
              >
                Nachricht senden
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
